import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Industries from './components/Industries';
import Projects from './components/Projects';
import Testimonials from './components/Testimonials';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

function App() {
  return (
    <div className="font-sans">
      <Navbar />
      <div className="pt-20">
        <section id="hero"><Hero /></section>
        <section id="about"><About /></section>
        <section id="services"><Services /></section>
        <section id="industries"><Industries /></section>
        <section id="projects"><Projects /></section>
        <section id="testimonials"><Testimonials /></section>
        <section id="contact"><Footer /></section>
      </div>
      <BackToTop />
    </div>
  );
}

export default App;
